import Text from "ab-text";
import ParagraphText from "ab-paragraph-text";
import { useViewportScroll, useTransform } from "framer-motion";

import "./ab-home.scss";
import MovingImage from "./Image";

const Home = ({ title, text = [], titulo, contenido, imagenes, imgmob }) => {
  const { scrollYProgress } = useViewportScroll();
  // console.log("Home ", scrollYProgress);
  const opacity = useTransform(scrollYProgress, [0, 0.1, 0.2], [0, 0.5, 1]);
  const yPosAnim = useTransform(
    scrollYProgress,
    [0, 0.2, 0.4],
    [0, -150, -250]
  );
  const opacity2 = useTransform(scrollYProgress, [0, 0.15, 0.25], [0, 0.5, 1]);
  const yPosAnim2 = useTransform(
    scrollYProgress,
    [0, 0.2, 0.4],
    [0, -200, -300]
  );
  const opacity3 = useTransform(scrollYProgress, [0, 0.2, 0.3], [0, 0.5, 1]);
  const yPosAnim3 = useTransform(
    scrollYProgress,
    [0, 0.2, 0.4],
    [0, -250, -350]
  );
  const opacity4 = useTransform(scrollYProgress, [0, 0.25, 0.35], [0, 0.5, 1]);
  const yPosAnim4 = useTransform(
    scrollYProgress,
    [0, 0.2, 0.4],
    [0, -300, -400]
  );
  const opacity5 = useTransform(scrollYProgress, [0, 0.3, 0.35], [0, 0.5, 1]);
  const yPosAnim5 = useTransform(
    scrollYProgress,
    [0, 0.2, 0.4],
    [0, -350, -450]
  );

  // console.log("Home", scrollYProgress);
  return (
    <div className="ab-home">
      <Text element="h2">{title || titulo}</Text>
      <ParagraphText text={text} content={contenido} singleColumn noPlus />

      <MovingImage
        className="spa"
        yPosAnim={yPosAnim2}
        image={imagenes?.[0]}
        imageMob={imgmob?.[1]}
      />

      <MovingImage
        className="mayordomo"
        yPosAnim={yPosAnim}
        image={imagenes?.[1]}
        imageMob={imgmob?.[0]}
      />

      <MovingImage
        className="bodega"
        yPosAnim={yPosAnim3}
        image={imagenes?.[2]}
        imageMob={imgmob?.[2]}
      />

      <MovingImage
        className="refectorio"
        yPosAnim={yPosAnim5}
        image={imagenes?.[3]}
        imageMob={imgmob?.[3]}
      />

      <MovingImage
        className="vinedos"
        yPosAnim={yPosAnim4}
        image={imagenes?.[4]}
        imageMob={imgmob?.[3]}
      />
    </div>
  );
};

export default Home;
